'use client'

import React from 'react'
import { Typography } from 'components/Contentful/Typography/Typography'
import { Dialog, DialogContent, DialogTitle } from 'components/Dialog'
import { IconButton } from 'components/IconButton'
import { X } from 'react-feather'

export const BillsRatingModal = ({
  modalStatus,
  setModalStatus,
  content = 'Bills.com ratings are calculated by aggregating pricing, quality, and service ratings from a variety of consumer and professional reviewers. Bills.com reviews are conducted by independent writers with no affiliation to any of the providers being reviewed.',
}) => {
  return (
    <Dialog
      open={modalStatus}
      onClose={() => setModalStatus(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogTitle id="alert-dialog-title" className="flex justify-end">
          <IconButton
            onClick={() => {
              setModalStatus(false)
            }}
          >
            <X />
          </IconButton>
        </DialogTitle>
        <Typography variant="bodyMd" content={content} />
      </DialogContent>
    </Dialog>
  )
}

export default BillsRatingModal
